import useCurrentPlan from "../../../hooks/useCurrentPlan";

const SimulationHeading = () => {
    const { hasPlan, headingData } = useCurrentPlan();

    if (!hasPlan || !headingData) {
        return null;
    }

    return (
        <div className="pb-3">
            <div className="d-flex align-items-start justify-content-between gap-3">
                <div>
                    <h1 className="fw-normal mb-0 !k-text-subtle" style={{ fontSize: "18px" }}>
                        {headingData.objective}
                        {headingData.skuName && (
                            <>
                                {" for "}
                                <span className="fw-bold text-dark">{headingData.skuName}</span>
                            </>
                        )}
                        {headingData.subBrandName && (
                            <>
                                {" for "}
                                <span className="fw-bold text-dark">{headingData.subBrandName}</span>
                            </>
                        )}
                        {headingData.retailers && (
                            <>
                                {" at "}
                                {headingData.retailers}
                            </>
                        )}
                    </h1>
                </div>
            </div>
        </div>
    );
};

export default SimulationHeading;
